export const ARRAY_MODIFIER_MAX_COUNT = 64;

export function clampArrayModifierCount(value: number): number {
  if (!Number.isFinite(value)) return 1;
  return Math.max(1, Math.min(ARRAY_MODIFIER_MAX_COUNT, Math.round(value)));
}
